export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.cdc21ec1.woff";